<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('customers.name') })" v-model="form.name" :label='$t("customers.name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.business_name_placeholder")' :danger="$v.form.business_name.$invalid && $v.form.business_name.$model" :danger-text="$t('validation.required', { attribute: $t('customers.business_name') })" v-model="form.business_name" :label='$t("customers.business_name")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.phone_placeholder")' :danger="$v.form.phone.$invalid && $v.form.phone.$model" :danger-text="$t('validation.required', { attribute: $t('customers.phone') })" v-model="form.phone" :label='$t("customers.phone")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.email_placeholder")' :danger="$v.form.email.$invalid && $v.form.email.$model" :danger-text="$t('validation.required', { attribute: $t('customers.email') })" v-model="form.email" :label='$t("customers.email")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.rfc_placeholder")' :danger="$v.form.rfc.$invalid && $v.form.rfc.$model" :danger-text="$t('validation.required', { attribute: $t('customers.rfc') })" v-model="form.rfc" :label='$t("customers.rfc")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(autofocus :placeholder='$t("customers.address_placeholder")' :danger="$v.form.address.$invalid && $v.form.address.$model" :danger-text="$t('validation.required', { attribute: $t('customers.address') })" v-model="form.address" :label='$t("customers.address")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, email, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'ModalCustomers',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        name: {
          required
        },
        business_name: {
          required
        },
        phone: {
          numeric,
          required
        },
        email: {
          email,
          required
        },
        rfc: {
          required
        },
        address: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ])
  }
}
</script>
